import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import trophy from '../images/trophy.png';

class Nav extends Component {

  render() {
    return (
      <nav className="navbar navbar-default">
        <div className="container-fluid">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle collapsed navbar-left" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <a className="navbar-brand" href="/"><img alt="Logo" src={trophy} /></a>
          </div>

          <div className="collapse navbar-collapse" id="navbar-collapse">
            <ul className="nav navbar-nav">
              <li className="active"><Link to="/">HOME <span className="sr-only">(current)</span></Link></li>
              <li className="divider-vertical"></li>
              <li><Link to="/hangon">FEATURED CHALLENGES</Link></li>
              <li className="divider-vertical"></li>
              <li><Link to="/partners">PARTNERS</Link></li>
            </ul>
            <div>
              <form action="https://www.paypal.com/cgi-bin/webscr" method="post">
                  <input type="hidden" name="business"
                         value="seth@snapchallenge.com"/>

                      <input type="hidden" name="cmd" value="_donations"/>
                          <input type="hidden" name="item_name" value="Donations to SnapChallenge"/>
                              <input type="hidden" name="item_number" value="Website Donation"/>
                                  <input type="hidden" name="currency_code" value="USD"/>

                                      <input type="image" name="submit"
                                             src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif"
                                             alt="Donate" />
                                          <img alt="" width="1" height="1"
                                               src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" />

              </form>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default Nav;


// WEBPACK FOOTER //
// ./src/components/Nav.js